import OutcomeDescriptionMapper from './outcome-description-mapper';

const OutcomeDescriptionModel = {
    mapper: OutcomeDescriptionMapper,

    id: {
        type: String,
    },

    labels: {
        type: Object,
    },

    names: {
        type: Object,
    },
};

export default OutcomeDescriptionModel;
